var util = require('widgets-util');
var loadJS = require('./load-script');
var loadCSS = require('./load-css');
var async = require('./async');
var Api = require('./api');

var InGo = window.InGo = window.InGo || {};
var defaultOptions = { baseUrl: "https://ingo.me", version: '0.9.0' };

function runWidget(container, config, options)
{
    var opts = util.deepExtend({}, config.params, options);
    if (opts.debug && window.console) ;
    var methodName = config.type + 'Widget';
    if (InGo.$ && InGo.$.fn && InGo.$.fn[methodName]) {
        InGo.$(container)[methodName](opts);
    } else
    if (InGo[methodName]) {
        InGo[methodName](opts);
    } else {
        throw new Error('InGo: Unable to find ' + methodName);
    }
    if (typeof options.onLoad == "function") options.onLoad(config);
}

function loadWidget(el, config, options)
{
    if (options.debug && window.console) ;
    if (!InGo._widgets) InGo._widgets = {};
    if (!InGo._widgets[config.type + '-' + config.version]) {
        async.each(getAbsoluteUrls(config.css, config, options), loadCSS);
        async.eachOrdered(getAbsoluteUrls(config.js, config, options), loadJS, function() {
            InGo._widgets[config.type + '-' + config.version] = config.params;
            loadCustom(config.params);
            runWidget(el, config, options);
        });
    } else {
        InGo._widgets[config.type + '-' + config.version] = config.params;
        loadCustom(config.params);
        runWidget(el, config, options);
    }
}

// Inject inline styles and code
function loadCustom(config)
{
    if (config && typeof config.css_data == "string" && util.trim(config.css_data).match(/^<style/)) InGo.$(config.css_data).appendTo(document.head);
    if (config && typeof config.js_data == "string" && util.trim(config.js_data).match(/^<script/)) InGo.$(config.js_data).appendTo(document.head);
}

function ingoWidget(options)
{
    var self = this;
    options = util.deepExtend({}, defaultOptions, options);
    var api = new Api(options);
    if (options.debug && window.console) ;
    api.config({}, function(config) {
        if (config.useJQuery) {
            checkJQuery(options, function() {
                loadWidget(self, config, options);
            });
        } else {
            loadWidget(self, config, options);
        }
    });
    return this;
}

// Make sure all urls in the list are absolute, in same origin mode use the loader path for
// js/css files, they can be in the same or different folders(/js/, /css/)
function getAbsoluteUrls(list, config, options)
{
    var rx = /^(https?:\/\/|\/\/)/i, urls = [];
    if (!list || !list.length) return [];
    for (var i = 0; i < list.length; i++) {
        var url = typeof list[i] == "string" ? list[i] : "";
        if (!url) continue;
        if (options.sameOrigin && options.href && url.match("ingo." + config.type + ".widget")) {
            var file = url.split("/").pop();
            if (file.match(/\.css$/i) && options.href.match(/\/js\//i)) file = "../css/" + file;
            url = options.href + file;
        } else
        if (!list[i].match(rx)) {
            url = (options.host || "") + list[i];
        }
        urls.push(url);
    }
    if (options.debug && window.console) ;
    return urls;
}

function toCamel(name)
{
    return String(name || "").replace(/(?:[\-\_\.])(\w)/g, function (_, c) { return c ? c.toUpperCase () : ''; });
}

// Update or create new object with the given property, name can be a simple property name or a path of properties separated by dots,
// in such case all required intermediate object containers will be crated automatically.
function setProp(obj, name, value)
{
    
    if (!obj) obj = {};
    if (!name) return obj;
    name = name.split(".");
    var v = obj, n;
    for (var i = 0; i < name.length - 1; i++) {
        n = toCamel(name[i]);
        if (typeof obj[n] == "undefined") obj[n] = {};
        obj = obj[n];
    }
    n = toCamel(name[name.length - 1]);
    obj[n] = value == "true" ? true : value == "false" ? false : value.match(/^[0-9]+$/) ? parseInt(value, 10) : value.match(/^[0-9]+\.[0-9]+$/) ? parseFloat(value, 10) : value;
    return v;
}

// Load jQuery if needed and then call the callback, use InGo.$ instead of global jQuery from now on
function checkJQuery(options, callback)
{
    if (!InGo.$) InGo.$ = window.jQuery;
    if (InGo.$) {
        var ver = (InGo.$.fn ? InGo.$.fn.jquery : "0.0").split(".");
        if (options.debug && window.console) ;
        for (var i = 0; i < ver.length; i++) ver[i] = parseInt(ver[i], 10);
        if (!ver[0] || !ver[1] || (ver[0] <= 1 && ver[1] < 7)) InGo.$ = null;
    }
    if (InGo.$) {
        InGo.$.fn.ingoWidget = InGo.$.fn.loaderWidget = ingoWidget;
        return callback();
    }
    if (options.debug && window.console) ;
    loadJS((options.href || "/js/") + "jquery.js", function(err) {
        if (err) throw err;
        if (!InGo.$) InGo.$ = jQuery.noConflict(true);
        InGo.$.fn.ingoWidget = InGo.$.fn.loaderWidget = ingoWidget;
        callback();
    });
}

// Return first not yet used <script> tag for our file
function getTag()
{
    if (!InGo._jstags) InGo._jstags = [];
    var rx = /\/ingo\.loader\.widget\.js/i;
    var tags = document.getElementsByTagName('script');
    for (var i = 0; i < tags.length; i++) {
        var tag = tags[i];
        if (!tag.parentNode || !tag.src.match(rx)) continue;
        for (var j = 0; tag && j < InGo._jstags.length; j++) if (InGo._jstags[j] == tag) tag = null;
        if (!tag) continue;
        InGo._jstags.push(tag);
        return tag;
    }
    return null;
}

// Parse tag atrributes, set defaults, returns an object with attributes
function parseTag(tag)
{
    if (!tag) return {};
    // Collect all attributes passed in the script tag
    var options = {};
    for (var i in tag.attributes) {
        var name = tag.attributes[i].name;
        if (name && name.substr(0, 10) == "data-ingo-") setProp(options, name.substr(10), tag.attributes[i].value);
    }

    // Replace the base url for other widgets with the origin host, it is always absolute even if we are testing it locally
    var d = tag.src.match(/^(https?:\/\/|\/\/)/i);
    if (d) {
        options.href = tag.src.split("/").slice(0, -1).join("/") + "/";
        options.host = "//" + tag.src.replace(d[1], "").split("/")[0];
    }
    // In the same origin mode take all files from the same server
    if (options.sameOrigin || defaultOptions.sameOrigin) options.baseUrl = options.host;

    // Try to determine page language/locale
    if (!options.lang) {
        var html = document.querySelector("html");
        if (html && html.lang) options.langId = html.lang;
        if (!options.langId) {
            var meta = document.querySelector("meta[name=lang], meta[name=language], meta[itemprop=lang], meta[itemprop=language]");
            if (meta && meta.content) options.langId = meta.content;
        }
    }

    // Set widget type if no id is given or use default type, support widget type in the form of data-ingo-login, data-ingo-social
    if (!options.type && !options.id) {
        util.forEach(["login","social","registration","confirmation"], function(x) {
            if (!options.type && typeof options[x] != "undefined") options.type = x;
        });
    }
    if (options.debug && window.console) ;
    return options;
}

// Given a script tag with properties, try to instantiate a widget in place
function runTag(tag, options)
{
    if (!tag) return;
    if (!options) options = defaultOptions;
    // Only instantiate if we have id or type, otherwise just keep it loaded to be used directly from scripts
    if (!options.id && !options.type) return;
    // Inject in place and bind to optional target or anonymous div
    var div = options.target ? document.querySelector(options.target) : null;
    if (!div) {
        if (options.button) {
            div = document.createElement("button");
            div.appendChild(document.createTextNode(options.button));
        } else {
            div = document.createElement("div");
        }
    }
    tag.parentNode.insertBefore(div, tag);
    ingoWidget.call(div, options);
}

// Global widget reference
InGo.ingoWidget = InGo.loaderWidget = ingoWidget;
// To be able to launch widgets from the global jQuery selector
if (window.jQuery) window.jQuery.fn.ingoWidget = window.jQuery.fn.loaderWidget = ingoWidget;

// Extract tag attributes so we can use base url for loading other scripts
var tag = getTag();
runTag(tag, parseTag(tag));

